import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { ProjectOutcomeRelation } from '../models/outcomes/ProjectOutcomeRelation'

import { API_SETTINGS } from './API_SETTINGS';
import { OutcomeAction } from '../models/outcomes/OutcomeAction';
import { OutcomeActionType } from '../models/outcomes/OutcomeActionType';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const apiUrl = API_SETTINGS.API_URL + 'OutcomeAction';

@Injectable({
    providedIn: 'root'
})
export class ApiOutcomeActionsService {

    constructor(private http: HttpClient) { }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    getOutcomeActions(): Observable<OutcomeAction[]> {
        const url = apiUrl + '/GetOutcomeActions'
        return this.http.get<OutcomeAction[]>(url).pipe();
    }

    getOutcomeAction(id: number): Observable<OutcomeAction> {
        const url = `${apiUrl}/GetOutcomeAction/${id}`;
        return this.http.get<OutcomeAction>(url).pipe();
    }

    getOutcomeActionTypes(): Observable<OutcomeActionType[]> {
        const url = apiUrl + '/GetOutcomeActionTypes'
        return this.http.get<OutcomeActionType[]>(url).pipe();
    }

    getOutcomeActionType(id: number): Observable<OutcomeAction> {
        const url = `${apiUrl}/GetOutcomeActionType/${id}`;
        return this.http.get<OutcomeAction>(url).pipe();
    }

    getOutcomeActionBySceneId(id: number): Observable<OutcomeAction[]> {
        const url = `${apiUrl}/GetOutcomeActionBySceneId/${id}`;
        return this.http.get<OutcomeAction[]>(url).pipe();
    }

    getOutcomeActionBySceneAssetRelationId(id: number): Observable<OutcomeAction[]> {
        const url = `${apiUrl}/GetOutcomeActionBySceneAssetRelationId/${id}`;
        return this.http.get<OutcomeAction[]>(url).pipe();
    }

    // getProjectOutcomeRelationByProjectId(id: number): Observable<ProjectOutcomeRelation[]> {
    //     const url = `${apiUrl}/GetProjectOutcomeRelationByProjectId/${id}`;
    //     return this.http.get<ProjectOutcomeRelation[]>(url).pipe();
    // }

    addOutcomeAction(OutcomeAction: OutcomeAction): Observable<OutcomeAction> {
        const url = apiUrl + '/PostOutcomeAction'
        return this.http.post<OutcomeAction>(url, OutcomeAction, httpOptions).pipe();
    }

    // AddProjectOutcomeRelationArray(projectOutcomeRelations: ProjectOutcomeRelation[]): Observable<ProjectOutcomeRelation[]> {
    //     const url = apiUrl + '/PostProjectOutcomeRelationArray'
    //     return this.http.post<ProjectOutcomeRelation[]>(url, projectOutcomeRelations, httpOptions).pipe();
    // }

    deleteOutcomeAction(id: number): Observable<OutcomeAction> {
        const url = `${apiUrl}/DeleteOutcomeAction/${id}`;
        return this.http.delete<OutcomeAction>(url, httpOptions).pipe();
      }
}